/* Performance Reel: collection and related card stock/variant sale math only. */
(function(){
  "use strict";
  if(window.__prCatalogCardUpdateInstalled)return;
  window.__prCatalogCardUpdateInstalled=true;
  var cache=new WeakMap();
  function variantsFor(card){
    if(cache.has(card))return cache.get(card);
    var src=card.querySelector('[data-pr-card-variants]'),list=[];
    if(src){try{list=JSON.parse(src.textContent||"[]")}catch(_err){list=[]}}
    cache.set(card,list);
    return list;
  }
  function money(card,cents){
    var cur=(card.querySelector('[data-pr-card-currency]')||{}).getAttribute;
    var elt=card.querySelector('[data-pr-card-currency]');
    var currency=(elt&&elt.getAttribute('data-pr-currency'))||'USD';
    try{
      return new Intl.NumberFormat('en-US',{style:'currency',currency:currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
    }catch(_err){
      return '$'+(cents/100).toFixed(2);
    }
  }
  function text(root,selector,value){
    var el=root.querySelector(selector);if(el)el.textContent=value;
  }
  function update(card,id){
    if(!card||!id)return;
    var list=variantsFor(card);
    var variant=list.find(function(v){return String(v.id)===String(id)});
    if(!variant)return;
    var price=Number(variant.price),compare=Number(variant.compare||0);
    if(!isFinite(price)||!isFinite(compare))return;
    var priceBox=card.querySelector('[data-pr-card-price]');
    var math=card.querySelector('[data-pr-card-math]');
    var onSale=compare>price;
    if(priceBox)priceBox.classList.toggle('pr-card-price--sale',onSale);
    if(math){
      math.hidden=!onSale;
      if(onSale){
        text(math,'[data-pr-card-original]',money(card,compare));
        text(math,'[data-pr-card-savings]','− '+money(card,compare-price));
        text(math,'[data-pr-card-final]',money(card,price));
      }
    }
    var skuWrap=card.querySelector('[data-pr-card-sku-wrap]');
    var dot=card.querySelector('[data-pr-card-dot]');
    var sku=variant.sku||'';
    if(skuWrap)skuWrap.hidden=!sku;
    if(dot)dot.hidden=!sku;
    text(card,'[data-pr-card-sku]',sku);
    var label='Out of stock';
    if(variant.available){
      var q=Number(variant.quantity);
      label=variant.managed==='shopify'&&q>0 ? String(q)+' available' : 'Available to order';
    }
    text(card,'[data-pr-card-inventory]',label);
  }
  document.addEventListener('click',function(event){
    var node=event.target.closest('[data-var_id]');
    if(!node)return;
    var card=node.closest('.pr-catalog-card');
    if(!card)return;
    var id=node.getAttribute('data-var_id');
    requestAnimationFrame(function(){update(card,id)});
  });
  document.addEventListener('change',function(event){
    var target=event.target;
    var card=target.closest('.pr-catalog-card');
    if(!card)return;
    var id='';
    if(target.matches('select')){
      var option=target.options[target.selectedIndex];
      if(option)id=option.getAttribute('data-var_id')||'';
    }else{
      id=target.getAttribute('data-var_id')||'';
    }
    if(id)requestAnimationFrame(function(){update(card,id)});
  });
})();
